import Swal from "sweetalert2"; // ✅ Import Swal
import React, { useContext, useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import { AuthContext } from "../../../context/Authcontext";
import axios from "axios";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";


const base_url = process.env.REACT_APP_API_URL;

const FancyBetsResult = () => {
  const navigate = useNavigate();
  const { eventid } = useParams();
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleResultChange = (e, fancyId) => {
    const updatedMatches = matches.map((match) =>
      match.fancyId === fancyId ? { ...match, result: e.target.value } : match
    );
    setMatches(updatedMatches);
  };

  const handleUpdateResult = async (fancyId) => {
    const matchToUpdate = matches.find((m) => m.fancyId === fancyId);
    if (!matchToUpdate || matchToUpdate.result === "") {
      toast.error("Please enter a valid result");
      return;
    }

    // ✅ SweetAlert confirmation
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: `You are about to update result for Fancy ID: ${fancyId}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    });

    if (!confirm.isConfirmed) return;

    try {
      const auth = localStorage.getItem("admin");
      const response = await axios.post(
        `${base_url}/api/webapi/admin/updateFancyResult`,
        {
          fancyId: matchToUpdate.fancyId,
          result: matchToUpdate.result,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );

      if (response.data.success) {
        toast.success(response.data.message);
        GetMyMatches();
      } else {
        toast.error(response.data.message);
      }
    } catch (err) {
      console.error("Error updating result", err);
      toast.error("Something went wrong");
    }
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const GetMyMatches = async () => {
    try {
      const auth = localStorage.getItem("admin");
      const response = await axios.get(
        `${base_url}/api/webapi/admin/fancyBets/${eventid}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );
      const data = response?.data.data;
      setMatches(data || []);
    } catch (error) {
      console.error("Error fetching matches:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetMyMatches();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setIsSidebarOpen(true);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="wrapper">
   

      <div
        className={`content-wrapper d-flex flex-column ${
          !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
        }`}
        style={{
          marginLeft: !isMobile && isSidebarOpen ? "" : "0",
          transition: "margin-left 0.3s ease",
        }}
      >
        <section className="content">
          <div className="mt-2 tophead d-flex justify-content-between">
            <div className="d-flex align-items-center cursor-pointer justify-content-center">
              <div className="top px-2">Fancy Bet Result Manage And Rollback</div>
            </div>
            <div className="d-flex gap-2 pb-1">
              <button
                type="button"
                className="btn btn-sm btn-primary refreshButton px-3 py-1"
                onClick={() => window.location.reload()}
              >
                Refresh
              </button>
            </div>
          </div>

          <div className="table-responsive">
            <table role="grid" className="table table-hover datatable table-striped mt-4">
              <thead className="bg-dark text-light">
                <tr>
                  <th>Fancy Id</th>
                  <th>Event Name</th>
                  <th>Competition Name</th>
                  <th>Fancy Name</th>
                  <th>Add Result</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {matches.length > 0 ? (
                  matches.map((match, index) => (
                    <tr key={index}>
                      <td className="text-bold">{match.fancyId}</td>
                      <td className="text-bold">{match.eventName}</td>
                      <td>{match.competitionName}</td>
                      <td>{match.runnerName}</td>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Result"
                          value={match.result || ""}
                          onChange={(e) => handleResultChange(e, match.fancyId)}
                        />
                      </td>
                      <td>
                        <button
                          className="btn btn-warning btn-sm ms-2"
                          onClick={() => handleUpdateResult(match.fancyId)}
                        >
                          Update
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No matches available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>
      </div>

      <a
        id="back-to-tops"
        href="##"
        className="btn btn-primary back-to-top"
        role="button"
        aria-label="Scroll to top"
      >
        <i className="fas fa-chevron-up" />
      </a>
    </div>
  );
};

export default FancyBetsResult; 